import EditVendorModal from "./EditVendorModal";

export default EditVendorModal;